import { getIdFromVideoUrl } from '../../utils/video/getIdFromVideoUrl'

export default function getExercisePlaylistData(entry) {
  if (!entry) return null

  const data = []
  const title = entry?.exerciseTitle || null
  const url = entry?.exerciseContent?.[0]?.exerciseVideoBlock?.[0]?.col1 || null
  if (title && url) {
    const videoId = getIdFromVideoUrl(url)
    data.push({ youtubeId: videoId, youtubeTitle: entry.exerciseTitle })
    return data
  } else {
    return null
  }
}
